export const PUNCH_WARNING_TIMEOUT_MS = 5000;
export const PUNCH_SUBMIT_HARD_TIMEOUT_MS = 15000;
export const PUNCH_TIMEOUT_WARNING_MESSAGE =
  'We are having trouble submitting your punch.  If we continue to have trouble your punch data will be saved and submitted later as an offline punch.';
